<template>
  <div class='table-box'>
    <div class='card-box'>
      <!-- 右边卡片 -->
      <div class='card-rb'>
        <div class='card-r'>
          <el-card style='width: 29%'>
            <div class='topbarnav'>
              <img src='../../../assets/images/icons/1.png' alt />
              <div>概览</div>
            </div>
            <div class='onebuttom'>
              <div class='oneleft'>
                <div>{{ systemConfig.systemDayCount }}</div>
                <div>系统上线天数</div>
              </div>
              <div class='oneright'>
                <div class='onebuttom-child-item onerighttop'>
                  <div>{{ systemConfig.systemLogCount }}</div>
                  <div>日志总量</div>
                </div>
                <div
                  class='onebuttom-child-item onerightbottom'
                >
                  <div>
                    {{ systemConfig.systemUserCount }}
                  </div>
                  <div>用户总量</div>
                </div>
              </div>
            </div>
          </el-card>
          <el-card style='width: 34%'>
            <div class='topbarnav'>
              <img src='../../../assets/images/icons/2.png' alt />
              <div>当日操作类型统计</div>
            </div>
            <div class='onebuttom'>
              <div class='onebuttom-chart' id='chart_1_1'></div>
            </div>
          </el-card>
          <el-card style='width: 34%'>
            <div class='topbarnav'>
              <img src='../../../assets/images/icons/9.png' alt />
              <div>当日来源统计</div>
            </div>
            <div class='onebuttom'>
              <div class='onebuttom-chart' id='chart_1_2'></div>
            </div>
          </el-card>
        </div>
        <div class='table-box'>
          <global-tag>
            <el-form
              :inline='true'
              :model='searchlist'
              class='demo-form-inline'
              size='mini'
            >
              <el-form-item label='用户名:'>
                <el-input
                  v-model='searchlist.operName'
                  placeholder='请输入用户名'
                  style='width: 130px'
                ></el-input>
              </el-form-item>
              <el-form-item label='操作日期：'>
                <el-date-picker
                  v-model='searchlist.logTime'
                  type='daterange'
                  value-format='yyyy-MM-dd'
                  range-separator='至'
                  start-placeholder='开始日期'
                  end-placeholder='结束日期'
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button
                  type='primary'
                  @click='searchlistdata'
                >查询
                </el-button
                >
              </el-form-item>
              <el-form-item>
                <el-button
                  type='info'
                  @click='searchlistReset'
                >重置
                </el-button
                >
              </el-form-item>
              <el-form-item></el-form-item>
            </el-form>
          </global-tag>
          <div class='three'>
            <el-button
              type='warning'
              size='mini'
              @click='createExcel'
            >按条件导出
            </el-button
            >
            <!-- <el-button type="danger" size="mini" @click="deleteRows()">删除</el-button> -->
          </div>
          <div class='table_card'>
            <el-table
              :data='tableData'
              :header-cell-style="{ background: '#f8fafa' }"
              border
              align='center'
              current-row-key
              highlight-current-row
              @selection-change='handleSelectionChange'
            >
              <el-table-column type='expand'>
                <template slot-scope='props'>
                  <el-form
                    label-position='left'
                    inline
                    class='demo-table-expand'
                  >
                    <el-form-item label='请求参数:'>
                                                <span>{{
                                                    props.row.operParam
                                                  }}</span>
                    </el-form-item>
                    <el-form-item label='返回参数:'>
                                                <span>{{
                                                    props.row.jsonResult
                                                  }}</span>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column
                align='center'
                prop='operName'
                label='用户名'
              ></el-table-column>
              <el-table-column
                align='center'
                prop='operIp'
                label='IP'
              ></el-table-column>
              <el-table-column
                align='center'
                prop='operLocation'
                label='IP来源'
              ></el-table-column>
              <el-table-column
                align='center'
                prop='title'
                label='模块'
              ></el-table-column>
              <el-table-column
                align='center'
                prop='requestMethod'
                label='操作类型'
              ></el-table-column>
              <el-table-column
                align='center'
                prop='method'
                label='操作内容'
              ></el-table-column>
              <el-table-column
                align='center'
                prop='processingTime'
                label='请求耗时'
              >
                <template slot-scope='scope'>
                  <el-tag
                    v-if='
                                                scope.row.processingTime <= 300
                                            '
                  >{{
                      scope.row.processingTime
                    }}ms
                  </el-tag
                  >
                  <el-tag
                    v-else-if='
                                                scope.row.processingTime <= 1000
                                            '
                    type='warning'
                  >{{
                      scope.row.processingTime
                    }}ms
                  </el-tag
                  >
                  <el-tag v-else type='danger'
                  >{{
                      scope.row.processingTime
                    }}ms
                  </el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column
                align='center'
                prop='operUrl'
                label='操作路径'
              ></el-table-column>
              <el-table-column
                align='center'
                prop='operTime'
                label='操作时间'
              ></el-table-column>
            </el-table>
            <!-- 分页功能 -->
            <el-pagination
              :page-size='pageConfig.pageSize'
              layout='total, prev, pager, next, jumper'
              @current-change='handleCurrentChange'
              :total='pageConfig.total'
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/system.css'
import echarts_msg from '../../../utils/echarts.js'
import request from '../../../utils/request.js'

export default {
  data() {
    return {
      multipleSelection: [],
      systemConfig: {
        systemDayCount: 0,
        systemLogCount: 0,
        systemUserCount: 0
      },
      searchlist: {},
      tableData: [],
      // 操作类型
      charOperationType: [],
      charOperationTypeNum: [],
      charSourceType: [],
      charSourceTypeNum: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      }
    }
  },
  methods: {
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    searchlistReset() {
      this.searchlist = {}
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getPageDatas()
    },
    //获取列表数据
    async getPageDatas() {
      this.searchlist.pageNo = this.pageConfig.pageNo
      this.searchlist.pageSize = this.pageConfig.pageSize
      this.searchlist.qujiId = JSON.parse(
        localStorage.getItem('czUserInfo')
      ).qujiId
      this.searchlist.shengjiId = JSON.parse(
        localStorage.getItem('czUserInfo')
      ).shengjiId
      this.searchlist.shijiId = JSON.parse(
        localStorage.getItem('czUserInfo')
      ).shijiId
      this.searchlist.stationId = JSON.parse(
        localStorage.getItem('czUserInfo')
      ).stationId
      let params = JSON.stringify(this.searchlist)
      // console.log(params)
      var res = await request({
        url: '/rbac/admin/system/log/list',
        method: 'POST',
        data: params
      })
      if (res.code == 200) {
        if (res.content != null) {
          this.pageConfig.total = res.content.count
          this.tableData = res.content.list
        } else {
          this.pageConfig.total = 0
          this.tableData = []
        }
      } else if (res.code == '10004') {
        this.$message.error(res.message)
        this.$router.push('/login')
      } else {
        console.log(res)
        this.$message({
          message: '数据加载异常',
          type: 'error'
        })
      }
    },
    drawChart() {
      //按操作类型统计，柱状图
      var option_1_1_text = this.charOperationType
      var option_1_1_data = this.charOperationTypeNum
      let myChart_l_1 = this.$echarts.init(
        document.getElementById('chart_1_1')
      )
      const that = this
      var option_1_1 = {
        title: {
          text: '',
          left: 'left',
          textStyle: {
            fontSize: 12,
            color: '#222121',
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },

        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          data: option_1_1_text
        },
        series: [
          {
            type: 'bar',
            itemStyle: {
              normal: {
                color: that.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  1,
                  0,
                  [
                    { offset: 0, color: '#ff8383' },
                    { offset: 1, color: '#ffe5e6 ' }
                  ]
                )
              }
            },
            data: option_1_1_data
          }
        ]
      }

      myChart_l_1.setOption(option_1_1)

      //按操作来源统计，饼状图
      /* var option_1_2_data = [
      {value: 34567, name: 'PC端'},
      {value: 56789, name: '移动端'}
    ] */
      let myChart_1_2 = this.$echarts.init(
        document.getElementById('chart_1_2')
      )
      var option_1_2 = echarts_msg.option_pie
      option_1_2.legend.data = this.charSourceType
      option_1_2.series[0].name = '操作总量'
      option_1_2.series[0].data = this.charSourceTypeNum
      myChart_1_2.setOption(option_1_2)

      let sizeFun = function() {
        myChart_l_1.resize()
        myChart_1_2.resize()
      }
      window.addEventListener('resize', sizeFun)
    },
    //导出excel
    async createExcel() {
      let params = JSON.stringify(this.searchlist)
      var res = await request({
        url: '/rbac/admin/system/log/export',
        method: 'POST',
        data: params,
        responseType: 'blob'
      })

      const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
      const fileName = '操作日志信息.xls'
      const linkNode = document.createElement('a')

      linkNode.download = fileName //a标签的download属性规定下载文件的名称
      linkNode.style.display = 'none'
      linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
      document.body.appendChild(linkNode)
      linkNode.click() //模拟在按钮上的一次鼠标单击

      URL.revokeObjectURL(linkNode.href) // 释放URL 对象
      document.body.removeChild(linkNode)
    },
    handleSelectionChange(val) {
      // console.log(val)
      this.multipleSelection = val
    },
    //删除操作
    async deleteRows() {
      if (this.multipleSelection.length < 1) {
        this.$message({
          message: '请先选择您要删除的数据项',
          type: 'error'
        })
        return
      }
      this.$confirm('此操作将删除您选中的数据项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let ids = ''
          this.multipleSelection.forEach((item) => {
            ids = ids + ',' + item.id
          })
          let params = JSON.stringify({ ids: ids })
          console.log(params)
          return
          var res = await request({
            url: '/rbac/admin/user/info/deleteUser',
            method: 'POST',
            data: params
          })
          if (res.code == 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.pageConfig.pageNo = 1
            this.getPageDatas()
          } else if (res.code == '10004') {
            this.$message.error(res.message)
            this.$router.push('/login')
          } else {
            console.log(res)
            this.$message({
              message: '删除失败：' + res.message,
              type: 'error'
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    async loadSystemDatabase() {
      // 加载系统运行 统计数据
      var res = await request({
        url: '/rbac/admin/system/log/operationLogReport',
        method: 'POST',
        data: {}
      })
      console.log(res)
      if (res.code == 200) {
        console.log(res.content, '操作日志')
        this.systemConfig.systemUserCount = res.content.userCount
        this.systemConfig.systemLogCount = res.content.logCount
        this.systemConfig.systemDayCount = res.content.onlineDays
        // 操作类型统计
        this.charOperationType = []
        this.charOperationTypeNum = []
        if (res.content.todayOperLogTypeCount) {
          res.content.todayOperLogTypeCount.forEach((item) => {
            this.charOperationType.push(item.title)
            this.charOperationTypeNum.push(item.countNum)
          })
        }

        // // 来源统计
        this.charSourceType = []
        this.charSourceTypeNum = []
        if (res.content.todayAccessSourceCount) {
          res.content.todayAccessSourceCount.forEach((item) => {
            this.charSourceType.push(item.accessSource)
            this.charSourceTypeNum.push({
              name: item.accessSource,
              value: item.countNum
            })
          })
        }

        this.drawChart()
      } else if (res.code == '10004') {
        this.$message.error(res.message)
        this.$router.push('/login')
      }
    }
  },
  mounted() {
    this.getPageDatas()
    this.loadSystemDatabase()
  }
}
</script>
<style lang='less' scoped>
.el-card {
  border-radius: 16px;
}

.oneleft {
  float: left;
  width: 35%;
  margin-top: 25%;
  height: 30%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-between;
  text-align: center;
  flex-wrap: wrap;

  div:first-child {
    width: 100%;
    color: red;
    font-size: 30px;
  }

  div:last-child {
    width: 100%;
  }
}

.oneright {
  float: left;
  width: 65%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: space-around;
  flex-wrap: wrap;

  .onerighttop {
    width: 85%;
    height: 40%;
    margin-top: 5%;
  }

  .onerightbottom {
    width: 85%;
    height: 40%;
  }
}

demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 70px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}

.demo-table-expand .el-form-item__content {
  font-size: 12px;
}
</style>
